import { atom } from "recoil";

export const loaderState = atom({
  key: "loaderState",
  default: false,
});
